import React from 'react'
import {
    Grid,
    GridCellProps,
    GridColumn as Column,
    GridItemChangeEvent,
    GridPageChangeEvent,
    GridPagerSettings,
    GridRowProps,
    GridNoRecords
  } from "@progress/kendo-react-grid";
  import { useState } from "react";
  import { orderBy, SortDescriptor } from "@progress/kendo-data-query";
  import { useNavigate } from "react-router-dom";
  import { checkStatus } from "../../utils/EllowUtils";
  import { Icon } from "@iconify/react";
import { postAPI } from '../../api/apis';
import { REACT_APP_CANDIDATE_FREELANCER } from '../../utils/common';


function ContractTable(props: any) {

    return (
      <section className="tableStyle no-padd-top no-min-height tableMaxHeight">
        <Grid
            data={props.data}
            sortable={true}
        >    
          <GridNoRecords>
            <div className="noData">
              <Icon icon="mdi:smiley-neutral-outline" />
              No data to display
            </div>
          </GridNoRecords>
        <Column field="company" title="Company" className="break-all" cell={CompanyCell}/>
        <Column field="position" title="Position" className="break-all" cell={PositionCell}/>
        <Column field="startDate" title="Start Date" className="break-all" cell={StartDateCell}/>    
        <Column field="endDate" title="End Date" className="break-all" cell={EndDateCell}/>
        <Column field="contractRate" title="Contract Rate" className="break-all" cell={ContractRateCell} /> 
        <Column cell={viewContract} width="100px"/>
        <Column cell={ViewButton}  width="120px" />
    </Grid>
    </section>
  )
}

export default ContractTable


const viewContract = (props: GridCellProps) => {

  const downloadContract = (signDetails: any) => {
    let fileName = signDetails && signDetails.documentname
            let value = {
              "action": "getObject",
              "filename": `contractAgreementLetters/${fileName}`,
              "bucketName": "ellow-satge-dashboard-upload",
            };
            
            postAPI(REACT_APP_CANDIDATE_FREELANCER + '/resume-signed-url', value).then((data) => {
              let signedUrl = data.url;
              fetch(signedUrl).then(response => {
        
                response.blob().then(blob => {
                    const fileURL = window.URL.createObjectURL(blob);
                    let alink = document.createElement('a');
                    alink.href = fileURL;
                    alink.download =`${fileName}.pdf`;
                    alink.click();
                })
            })
            })
 }

  return (
    <td> { props.dataItem.contractSigned && 
      <button type="button" className="link-btn" onClick={() => downloadContract(props.dataItem.contractSignDetails)}>
        View Contract
      </button>
    }
    </td>
  )
}


const CompanyCell = (props: GridCellProps) => {
   
    return (
      <td >
         <div className="dateWrap">
            {props.dataItem.companyName}
        </div>
      </td>
    )
  }

  const PositionCell = (props: GridCellProps) => {
    return (
      <td >
        <div className="email">
          {props.dataItem.jobRole}
        </div>
      </td>
    )
  }

  const StartDateCell = (props: GridCellProps) => {
  
    let dateNumber = parseInt(props.dataItem.contractStartDate)
    let date = new Date(dateNumber).toDateString()

    return (
      <td >
        <div className="dateWrap">
            {date}
        </div>
      </td>
    )
  }

  const EndDateCell = (props: GridCellProps) => {
    
    let dateNumber = parseInt(props.dataItem.contractEndDate)
    let date = new Date(dateNumber).toDateString()

    return (
      <td >
        <div className="dateWrap">
            {date}
        </div>
      </td>
    )
  }

  const ContractRateCell = (props: GridCellProps) => {
    
    return (
      <td >
            {props.dataItem.currencyType === "INR" ? 
              <div className="dateWrap">
              ₹ {" " + props.dataItem.contractRate + " "} / {props.dataItem.billingType}
              </div>
              : 
              <div className="dateWrap">
              $ {" " + props.dataItem.contractRate + " "} / {props.dataItem.billingType}
              </div>
            }
      </td>
    )
  }

  const ViewButton = (props: GridCellProps) => {

    const navigate = useNavigate()
    return (
      <td>
        <button  type="button" className="link-btn" onClick={(e: any) => navigate('/timesheet', { state: { candidateId: props.dataItem.candidateId, candidateJobId: props.dataItem.candidateJobId}})}>
        View TImesheet
        </button>
      </td>
    );
  }